var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactWithoutCalling',{attrs:{"module":"sales"}})
}
var staticRenderFns = []

export { render, staticRenderFns }